export const CONTROLLERS = {
  Agencies: 'organizations/talent-agency',
  AgencyTalents: 'organizations/talent-agency/talents',
  Organizations: 'organizations',
};
